import React from "react";

import DropdownIconWhite from '../../assets/icons/arrow_down_white.png';
import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from "../../utilities/CommonMethods";
import classes from './TopbarProgramStrip.module.css';
import Button from '../UI/Button/Button';
import { connect } from "react-redux";
import * as actionCreators from '../../store/actions/mainLayoutActions';
import { Link, Redirect, withRouter } from "react-router-dom";
import RouteEndPoints from "../../utilities/RouteEndPoints";
import Constants from "../../utilities/Constants";
import ResourceAPIController from "../../webServices/ResourceAPIController";
import SortHelper from "../../utilities/SortHelper";
// import LearnerBadge from "../LearnerBadge/LearnerBadge";
// import DailyFeedbackPupup from "../Popups/DailyFeedbackPupup/DailyFeedbackPupup";
// import NewDailyFeedbackPupup from "../Popups/NewDailyFeedbackPupup/NewDailyFeedbackPopup";

import EventBeepLogo from '../../assets/event_beep_logo.png'

class TopbarProgramStrip extends React.Component {

    state = {
        programDropdownOpen: false,
        enrolledPrograms: [],
        activeProgram: 0,
        activeProgramName: '',
        reloadingData: false,
        currentProgram: { batchCode: '', programName: 'Loading...', progress: 0 },
        currentModule: {},
        ongoingModuleData: {},
        enrolledModules: [],
        activeModule: 0,
        isLearner: false,
        redirectToHome: false,
        enableLiveSessionButton: false,
        isProgramManager: this.props.isProgramManager,
        previousTopicFeedback: []
    }

    progressBarRef = React.createRef();

    onModuleClicked = (pos) => {
        if (this.state.activeModule !== pos) {
            const updatedCurrentModule = { ...this.state.enrolledModules[pos] };
            // alert('pos ' + pos)
            // this.props.setActiveModuleName({ id: updatedCurrentModule.moduleId, moduleName: updatedCurrentModule.moduleName });
            this.props.setActiveModuleId({
                id: updatedCurrentModule.moduleId,
                batchCode: updatedCurrentModule.batchCode,
                moduleName: updatedCurrentModule.moduleName
            });

            this.props.redirectToHome(true);

            this.setState({ activeModule: pos, currentModule: updatedCurrentModule, programDropdownOpen: false, reloadingData: true, redirectToHome: true });
        } else {
            this.setState({ programDropdownOpen: false });
        }



        if (this.progressBarRef.current !== undefined && this.progressBarRef.current !== null) {
            this.progressBarRef.current.style.opacity = 1;
        }
        this.props.history.push(RouteEndPoints.HOME_PAGE);
    }

    onProgramClicked = (pos, batchCode) => {
        if (this.state.activeProgram !== pos) {
            const updatedCurrentProgram = { ...this.state.enrolledPrograms[pos] };

            this.props.setActiveProgramId({ id: updatedCurrentProgram.programId, batchCode: updatedCurrentProgram.programBatchCode, type: updatedCurrentProgram.type });

            this.setState({ activeProgram: pos, currentProgram: updatedCurrentProgram, programDropdownOpen: false, reloadingData: true });

            // console.log('program id', batchCode)
        } else {
            this.setState({ programDropdownOpen: false });
        }
        if (this.progressBarRef.current !== undefined && this.progressBarRef.current !== null) {
            this.progressBarRef.current.style.opacity = 1;
        }
    }

    onProgramDropdownClick = () => {
        const dropdownState = this.state.programDropdownOpen;
        if (this.progressBarRef.current !== undefined && this.progressBarRef.current !== null) {
            this.progressBarRef.current.style.opacity = dropdownState ? 1 : 0;
        }
        this.setState({ programDropdownOpen: !dropdownState });
    }

    getInstructorPostLoginDetailsForModule = (batchCode, moduleName) => {
        // alert('Getting Data for Module ' + batchCode + ' ' + moduleName)
        // this.setState({ loadingData: true });
        ResourceAPIController.userPostLoginDataInstructorForModule(batchCode, moduleName)
            .then(response => {

                let responseObj = response.result;
                // console.log('Post Login Data Instructor Response => ', responseObj, responseObj.enrolledModules)

                let enrolledModules = SortHelper.sortEnrolledModules(responseObj.enrolledModules)
                this.props.setInitialModuleData(responseObj.moduleOverviewData, responseObj.ongoingModuleData, enrolledModules);

                this.setState({
                    ongoingModuleData: responseObj.ongoingModuleData
                });
            })
            .catch(err => {
                // console.log('Post Login Data Instructor error => ', err)
                // this.setState({ loadingData: false });
                // if (IsObjectEmpty(err.error)) {
                //     // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                //     return;
                // }
                // if (err.error.status === 400) {
                //     this.props.onFailureDialogShow(err.error.message, 'OKAY');
                // }
                // if (err.error.status === 401) {
                //     if (err.error.message === 'Invalid token.') {
                //         this.props.showSessionExpiredDialog(true);
                //     } else {
                //         this.props.redirectToUnauthorized();
                //     }
                // }
                // if (err.error.status === 404) {
                //     this.props.redirectToNotFound();
                // }
                // if (err.error.status === 500) {
                //     this.props.redirectToServerError();
                // }
            });
    }

    getContinueLearningData = batchCode => {
        // this.setState({ loadingData: true });
        let responseObj = null;
        ResourceAPIController.getContinueLearningData(batchCode)
            .then(response => {
                responseObj = response.result;
                // console.log('PostLoginHome - getContinueLearningData - response => ', response.result);

                this.props.setInitialProgramData(
                    responseObj.continueLearningData,
                    responseObj.ongoingProgram,
                    responseObj.enrolledPrograms);

                this.setState({ previousTopicFeedback: responseObj.previousTopicFeedback });

            })
            .catch(err => {
                // console.log('Post Login Data error => ', err)
                this.setState({ loadingData: false });
                // if (IsObjectEmpty(err.error)) {
                //     // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                //     return;
                // }
                // if (err.error.status === 400) {
                //     this.props.onFailureDialogShow(err.error.message, 'OKAY');
                // }
                // if (err.error.status === 401) {
                //     if (err.error.message === 'Invalid token.') {
                //         this.props.showSessionExpiredDialog(true);
                //     } else {
                //         this.props.redirectToUnauthorized();
                //     }
                // }
                // if (err.error.status === 404) {
                //     this.props.redirectToNotFound();
                // }
                // if (err.error.status === 500) {
                //     this.props.redirectToServerError();
                // }
            });

    }

    checkInterval = null;

    setLiveSessionTimer = (data, clearPreviousInterval) => {

        if (this.checkInterval !== null && clearPreviousInterval === true) {
            clearInterval(this.checkInterval);
            this.setState({ enableLiveSessionButton: false });
        }

        let liveSessionId = !IsObjectEmpty(data) && !IsStringEmpty(data.liveSessionId) ? data.liveSessionId : '',
            liveSessionStarted = false;

        liveSessionStarted = data.started;
        let liveSessionData = {};
        this.props.updateLeanerLiveSessionStatus(liveSessionStarted, liveSessionData);

        if (!IsStringEmpty(liveSessionId)) {
            this.checkInterval = setInterval(() => {
                ResourceAPIController.getLearnerLiveSessionData(data.liveSessionId)
                    .then(response => {
                        // console.log(' 5 ---- getLearnerLiveSessionData Data => ', response.result.started, response.result.liveSessionId, data.liveSessionId)
                        liveSessionStarted = response.result.started;
                        liveSessionData = {
                            meetingId: response.result.meetingNumber,
                            encPassword: response.result.encPassword
                        }
                        if (liveSessionStarted === true) {
                            this.setState({ enableLiveSessionButton: liveSessionStarted });
                            this.props.updateLeanerLiveSessionStatus(liveSessionStarted, liveSessionData);
                        } else {
                            this.setState({ enableLiveSessionButton: liveSessionStarted });
                        }
                    })
                    .catch(err => {
                        console.log('getLearnerLiveSessionData error => ', err)
                        if (err.error.status === 400) {
                            this.props.onFailureDialogShow(err.error.message, 'OKAY');
                        }
                        if (err.error.status === 500) {
                            this.props.onFailureDialogShow("Something went wrong while fetching live session details. Please refresh the page", 'OKAY');
                        }
                    });

                if (liveSessionStarted === true) {
                    clearInterval(this.checkInterval);
                }
            }, 5000);
        }
    }

    closePopup = () => {
        let updatedPreviousTopicFeedback = this.state.previousTopicFeedback;
        updatedPreviousTopicFeedback.feedbackSubmitted = true;
        this.setState({ previousTopicFeedback: updatedPreviousTopicFeedback });
    }

    componentDidMount() {

        const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;
        if (isLearner) {
            if (!IsListEmpty(this.props.enrolledPrograms)) {
                const updatedCurrentProgram = this.props.enrolledPrograms.filter(program => program.programBatchCode === this.props.activeProgramBatchCode)[0];
                // const updatedCurrentProgram = this.props.ongoingProgram;
                this.setState({ activeProgram: 0, enrolledPrograms: this.props.enrolledPrograms, currentProgram: updatedCurrentProgram, isLearner: isLearner, redirectToHome: false });

                if (!IsObjectEmpty(this.props.continueLearningData) && !IsObjectEmpty(this.props.continueLearningData.todaysPlan) && !IsObjectEmpty(this.props.continueLearningData.todaysPlan.currentLiveSession)) {
                    const liveSessionData = this.props.continueLearningData.todaysPlan.currentLiveSession;
                    clearInterval(this.checkInterval);
                    this.setLiveSessionTimer(liveSessionData, false);
                }
            }
        } else {
            if (!IsListEmpty(this.props.enrolledModules)) {
                const updatedCurrentModule = { ...this.props.enrolledModules[0] };
                this.setState({
                    activeModule: 0,
                    enrolledModules: this.props.enrolledModules,
                    currentModule: updatedCurrentModule,
                    ongoingModuleData: { ...this.props.ongoingModuleData },
                    isLearner: isLearner, redirectToHome: false
                });
            }
        }

        // console.log('Topbar Mounted => ', isLearner, this.props);
    }

    componentDidUpdate(prevProps, prevState) {
        const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

        if (isLearner) {

            const currentSessionObj = !IsObjectEmpty(this.props.continueLearningData) &&
                !IsObjectEmpty(this.props.continueLearningData.todaysPlan) &&
                !IsObjectEmpty(this.props.continueLearningData.todaysPlan.currentLiveSession)
                ? this.props.continueLearningData.todaysPlan.currentLiveSession : {};

            const currentSessionId = !IsObjectEmpty(currentSessionObj) ? currentSessionObj.liveSessionId : '';

            const previousSessionId = !IsObjectEmpty(prevProps.continueLearningData) &&
                !IsObjectEmpty(prevProps.continueLearningData.todaysPlan) &&
                !IsObjectEmpty(prevProps.continueLearningData.todaysPlan.currentLiveSession)
                ? prevProps.continueLearningData.todaysPlan.currentLiveSession.liveSessionId : '';

            if ((currentSessionId !== previousSessionId && !IsStringEmpty(currentSessionId))) {
                const liveSessionData = !IsObjectEmpty(currentSessionObj) ? currentSessionObj : '';

                if (!IsObjectEmpty(liveSessionData)) {
                    this.setLiveSessionTimer(liveSessionData, true);
                }
            }

            if (prevProps.activeProgramBatchCode !== this.props.activeProgramBatchCode) {
                if (!IsStringEmpty(this.props.activeProgramBatchCode)) {
                    const pos = this.props.enrolledPrograms.findIndex(program => {
                        return program.programBatchCode === this.props.activeProgramBatchCode;
                    });
                    const updatedCurrentProgram = { ...this.props.enrolledPrograms[pos] };

                    const currentLiveSessionObj = !IsObjectEmpty(this.props.continueLearningData) && !IsObjectEmpty(this.props.continueLearningData.todaysPlan) && !IsObjectEmpty(this.props.continueLearningData.todaysPlan.currentLiveSession) ? this.props.continueLearningData.todaysPlan.currentLiveSession : {};

                    this.setState({ activeProgram: pos, enrolledPrograms: this.props.enrolledPrograms, currentProgram: updatedCurrentProgram, isLearner: isLearner, enableLiveSessionButton: currentLiveSessionObj.started, redirectToHome: false });
                    if (this.props.location.pathname !== '/') {
                        this.getContinueLearningData(this.props.activeProgramBatchCode);
                    }
                    if (!IsObjectEmpty(currentLiveSessionObj)) {
                        this.setLiveSessionTimer(currentLiveSessionObj, true);
                    }
                }
            }
        } else {
            if (prevProps.ongoingModuleData.moduleId !== this.props.ongoingModuleData.moduleId) {
                if (!IsStringEmpty(this.props.ongoingModuleData.moduleId)) {
                    const pos = this.props.enrolledModules.findIndex(module => {
                        return module.moduleId == this.props.ongoingModuleData.moduleId;
                    });
                    const updatedCurrentModule = { ...this.props.enrolledModules[pos] };

                    this.setState({
                        activeModule: pos,
                        enrolledModules: this.props.enrolledModules,
                        currentModule: updatedCurrentModule,
                        ongoingModuleData: { ...this.props.ongoingModuleData },
                        isLearner: isLearner,
                        redirectToHome: false
                    });
                }
            } else if (prevProps.activeModuleId !== this.props.activeModuleId) {
                if (!IsStringEmpty(this.props.activeModuleId)) {
                    const pos = this.props.enrolledModules.findIndex(module => {
                        return module.moduleId == this.props.activeModuleId && module.batchCode === this.props.activeProgramBatchCode;
                    });
                    const updatedCurrentModule = { ...this.props.enrolledModules[pos] };

                    if (this.props.location.pathname !== '/') {
                        this.getInstructorPostLoginDetailsForModule(updatedCurrentModule.batchCode, updatedCurrentModule.moduleName);
                    }

                    this.setState({
                        activeModule: pos,
                        currentModule: updatedCurrentModule,
                        redirectToHome: false
                    });
                }
            }
        }


        // console.log('Topbar Updated => ', isLearner, this.props);

    }

    componentWillUnmount() {
        clearInterval(this.checkInterval);
    }

    render() {
        const programList = !IsListEmpty(this.state.enrolledPrograms) ? this.state.enrolledPrograms.map((program, pos) => {
            return <li key={program.programBatchCode}
                className={this.state.activeProgram === pos ? classes.ActiveProgram : null}
                onClick={() => this.onProgramClicked(pos, program.id, program.programBatchCode)}>
                {program.programBatchCode}
            </li>
        }) : null;

        const count = document.documentElement.clientWidth > 1600 ? 10 : 8;

        const modulesList = !IsListEmpty(this.state.enrolledModules) ? this.state.enrolledModules.slice(0, count).map((module, pos) => {
            return (
                <li key={pos}
                    className={[classes.ModuleListItem, this.state.activeModule === pos ? classes.ActiveModule : null].join(' ')}
                    onClick={() => this.onModuleClicked(pos, module.moduleId, module.moduleName)}>
                    <img src={module.moduleLogo} alt="Module Logo"
                        className={classes.ModuleLogo} />
                    <div>
                        <h5 className={classes.ModuleName}>{module.moduleName}</h5>
                        <p className={classes.ModuleDate}>{module.startDate}</p>
                        <p className={classes.ModuleDate}>({module.batchCode})</p>
                    </div>
                </li>
            )
        }) : null;

        const showLiveSessionButton = !IsObjectEmpty(this.props.continueLearningData)
            && !IsObjectEmpty(this.props.continueLearningData.todaysPlan)
            && !IsObjectEmpty(this.props.continueLearningData.todaysPlan.currentLiveSession)
            && (this.props.continueLearningData.todaysPlan.currentLiveSession.status !== 'ended');

        const activeLiveSessionData = showLiveSessionButton ? this.props.continueLearningData.todaysPlan.currentLiveSession : {};


        // console.log('livesessionlist ===>>>', showLiveSessionButton, liveSessionsList, pos, activeLiveSessionData)

        const learnerBadge = GetFromLocalStorage(Constants.KEY_LEARNER_BADGE);

        const withStrip = this.props.hideProgramStrip !== true && GetFromLocalStorage(Constants.KEY_PROGRAM_STRIP) !== 'true';

        return (
            <>
                {this.state.redirectToHome ? <Redirect to={'/'} /> : null}
                {
                    this.props.isProgramManager ? null : this.props.isLearner === 'true'
                        ? <div className={classes.TopbarProgramStripContainer} id="TopbarProgramStrip">
                            {/* {
                                this.state.previousTopicFeedback.feedbackSubmitted ?
                                    null
                                    :
                                    <>
                                        {
                                            this.state.previousTopicFeedback.feedbackType === 'daily'
                                                ? this.state.previousTopicFeedback.subtopicExist ?
                                                    <DailyFeedbackPupup
                                                        show={true}
                                                        feedbackId={this.state.previousTopicFeedback.feedbackId}
                                                        nonCloseable={false}
                                                        closePopup={this.closePopup}
                                                        topicName={this.state.previousTopicFeedback.topicName}
                                                    />
                                                    : null
                                                : null
                                        }
                                        {
                                            this.state.previousTopicFeedback.feedbackType === 'new daily'
                                                ? <NewDailyFeedbackPupup
                                                    show={true}
                                                    feedbackId={this.state.previousTopicFeedback.feedbackId}
                                                    // date={this.state.currentTopic.scheduleDate || this.state.currentTopic.date}
                                                    topicId={this.state.previousTopicFeedback.topicId}
                                                    nonCloseable={false}
                                                    closePopup={this.closePopup}
                                                    topicName={this.state.previousTopicFeedback.topicName}
                                                />
                                                : null
                                        }
                                    </>
                            } */}

                            {
                                this.props.showTopbarProgramProgress
                                    ? <>
                                        <div className={classes.ProgramDetails}>

                                            {!IsListEmpty(this.state.enrolledPrograms)
                                                ? this.state.enrolledPrograms.length > 1
                                                    ? <>
                                                        <div className={classes.TopbarProgramDropdown} onClick={this.onProgramDropdownClick}>
                                                            <p className={classes.BatchCode}>{this.state.currentProgram.programBatchCode}</p>
                                                            <img src={DropdownIconWhite} alt="Program Dropdown Icon" className={[classes.DropdownIcon, this.state.programDropdownOpen ? classes.ActiveArrow : null].join(' ')} />
                                                        </div>
                                                        {this.state.programDropdownOpen
                                                            ? <div className={[classes.TopbarDropdown, !withStrip ? '' : classes.WithStrip].join(' ')}>
                                                                <span>Select Program</span>
                                                                <ul className={classes.ProgramList}>
                                                                    {programList}
                                                                </ul>
                                                            </div>
                                                            : null}
                                                    </>
                                                    : <div className={classes.TopbarProgramDropdown} style={{ 'cursor': 'auto' }}>
                                                        <p className={classes.BatchCode}>{this.state.currentProgram.programBatchCode}</p>
                                                        {/* <p className={classes.BatchCode}>{this.props.activeProgramBatchCode}</p> */}
                                                    </div>
                                                : ''
                                            }
                                            <h2>{this.state.currentProgram.programName}</h2>

                                            {
                                                this.props.ongoingProgram.type === 'event_beep'
                                                    ? <div className={classes.EventBeepLogoDiv}>
                                                        <span>Co-powered By</span>
                                                        <img src={EventBeepLogo} className={classes.EventBeepLogo} alt="EventBeep logo" />
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                        {/* <div className={classes.ProgressBarDiv} ref={this.progressBarRef} > */}
                                        {/* <div className={classes.ProgressContainer}><span className={classes.ProgressBar} style={{ 'width': this.state.currentProgram.programProgress + "%" }} ></span></div>
                                            <p className={classes.PercentText}>{this.state.currentProgram.programProgress}<span>%</span></p> */}
                                        {/* {!IsStringEmpty(learnerBadge) && this.props.ongoingProgram.isB2C === true
                                                ? <Link to={RouteEndPoints.BATCHMATES_PAGE + '/' + this.state.currentProgram.programBatchCode + '/my-badges'}
                                                    className={classes.RemoveTextDecoration}>
                                                    <LearnerBadge isLearner={true} learnerStatus={learnerBadge[0].toUpperCase() + learnerBadge.slice(1)} />
                                                </Link>
                                                : null} */}
                                        {
                                            showLiveSessionButton && !IsObjectEmpty(activeLiveSessionData)
                                                ? <>
                                                    <div className={classes.RightSection}>
                                                        <p className={classes.BeginsText}>
                                                            {
                                                                activeLiveSessionData.started || this.state.enableLiveSessionButton
                                                                    ? 'Live Session is Started'
                                                                    : `STARTS AT ${activeLiveSessionData.scheduleTime}`
                                                            }
                                                        </p>
                                                        <Button
                                                            label='JOIN SESSION'
                                                            fontSize="0.875em"
                                                            clicked={!activeLiveSessionData.started &&
                                                                !this.state.enableLiveSessionButton ? null : () => this.props.showLiveSessionPopup(activeLiveSessionData.liveSessionId)}
                                                            disabled={!activeLiveSessionData.started &&
                                                                !this.state.enableLiveSessionButton}
                                                            styleclass={!activeLiveSessionData.started &&
                                                                !this.state.enableLiveSessionButton ? "DarkDisabled" : ""}
                                                            margin="0px"
                                                            padding="0.75em 2.5em"
                                                        />
                                                    </div>
                                                </>
                                                : null
                                        }
                                        {/* </div> */}
                                    </>
                                    : <>
                                        <div className={classes.ProgramDetails}>
                                            {/* {
                                                this.props.ongoingProgram.type === 'event_beep'
                                                    ? <img src={EventBeepLogo} className={classes.EventBeepLogo} alt="EventBeep logo" />
                                                    : null
                                            } */}
                                            <div className={classes.TopbarProgramDropdown} style={{ 'cursor': 'auto' }}>
                                                <p className={classes.BatchCode}>{this.state.currentProgram.programBatchCode}</p>
                                            </div>
                                            <h2>{this.state.currentProgram.programName}</h2>
                                            {
                                                this.props.ongoingProgram.type === 'event_beep'
                                                    ? <div className={classes.EventBeepLogoDiv}>
                                                        <span>Co-powered By</span>
                                                        <img src={EventBeepLogo} className={classes.EventBeepLogo} alt="EventBeep logo" />
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                        {
                                            showLiveSessionButton && !IsObjectEmpty(activeLiveSessionData)
                                                ? <>
                                                    <div className={classes.RightSection}>
                                                        <p className={classes.BeginsText}>
                                                            {
                                                                activeLiveSessionData.started || this.state.enableLiveSessionButton
                                                                    ? 'Live Session is Started'
                                                                    : `STARTS AT ${activeLiveSessionData.scheduleTime}`
                                                            }
                                                        </p>
                                                        <Button
                                                            label='JOIN SESSION'
                                                            fontSize="0.875em"
                                                            clicked={!activeLiveSessionData.started &&
                                                                !this.state.enableLiveSessionButton ? null : () => this.props.showLiveSessionPopup(activeLiveSessionData.liveSessionId)}
                                                            disabled={!activeLiveSessionData.started &&
                                                                !this.state.enableLiveSessionButton}
                                                            styleclass={!activeLiveSessionData.started &&
                                                                !this.state.enableLiveSessionButton ? "DarkDisabled" : ""}
                                                            margin="0px"
                                                            padding="0.75em 2.5em"
                                                        />
                                                    </div>
                                                </>
                                                : null
                                        }
                                    </>
                            }
                        </div>
                        : <div className={classes.TopbarProgramStripContainer} id="TopbarProgramStrip">
                            {
                                this.props.showModuleProgress
                                    ? <>
                                        <div className={classes.ProgramDetails}>
                                            {!IsListEmpty(this.state.enrolledModules)
                                                ? this.state.enrolledModules.length > 1
                                                    ? <>
                                                        <div className={classes.TopbarProgramDropdown} onClick={this.onProgramDropdownClick}>
                                                            <img src={this.state.currentModule.moduleLogo} alt="Module Logo"
                                                                className={classes.ModuleLogo} />
                                                            <div>

                                                                <h2 className={classes.ModuleName}>{this.state.currentModule.moduleName}</h2>
                                                                <p className={classes.ModuleDate}>{this.state.currentModule.startDate}  ({this.state.currentModule.batchCode})</p>
                                                            </div>
                                                            <img src={DropdownIconWhite} alt="Modules Dropdown Icon" className={[classes.DropdownIcon, this.state.programDropdownOpen ? classes.ActiveArrow : null].join(' ')} />

                                                        </div>
                                                        {this.state.programDropdownOpen
                                                            ? <div className={classes.TopbarDropdown}>
                                                                <span>Select Module</span>
                                                                <ul className={classes.ProgramList}>
                                                                    {modulesList}
                                                                </ul>
                                                                <Link to={RouteEndPoints.ALL_MODULES_PAGE} className={classes.RemoveTextDecoration} onClick={this.onProgramDropdownClick}>
                                                                    <p className={classes.AllModulesTextLink}>VIEW ALL MODULES</p>
                                                                </Link>
                                                            </div>
                                                            : null}
                                                    </>
                                                    : <div className={classes.TopbarProgramDropdown} style={{ 'cursor': 'auto' }}>
                                                        <img src={this.state.currentModule.moduleLogo} alt="Module Logo"
                                                            className={classes.ModuleLogo} />
                                                        <div>

                                                            <h2 className={classes.ModuleName}>{this.state.currentModule.moduleName}</h2>
                                                            <p className={classes.ModuleDate}>
                                                                {this.state.currentModule.startDate} ({this.state.currentModule.batchCode})</p>
                                                        </div>
                                                    </div>
                                                : ''
                                            }

                                        </div>
                                        <div className={[classes.ProgresBarDiv, classes.ModuleProgress].join(' ')} ref={this.progressBarRef} >
                                            {/* <p className={classes.PercentText}>Progress</p>
                                            <p className={classes.PercentText}>{this.state.ongoingModuleData.moduleProgress}<span>%</span></p>
                                            <div className={classes.ProgressContainer}>
                                                <span className={classes.ProgressBar} style={{ 'width': this.state.ongoingModuleData.moduleProgress + "%" }} ></span>
                                            </div> */}
                                        </div>
                                    </>
                                    : <>
                                        <div className={classes.ProgramDetails}>
                                            {!IsListEmpty(this.state.enrolledModules)
                                                ? this.state.enrolledModules.length > 1
                                                    ? <>
                                                        <div className={classes.TopbarProgramDropdown} onClick={this.onProgramDropdownClick}>
                                                            <img src={this.state.currentModule.moduleLogo} alt="Module Logo"
                                                                className={classes.ModuleLogo} />
                                                            <div className={classes.ModuleTitleDiv}>

                                                                <h2 className={classes.ModuleName}>{this.state.currentModule.moduleName}</h2>
                                                                <p className={classes.ModuleDate}>{this.state.currentModule.startDate} ({this.state.currentModule.batchCode})</p>
                                                            </div>
                                                            <img src={DropdownIconWhite} alt="Modules Dropdown Icon" className={[classes.DropdownIcon, this.state.programDropdownOpen ? classes.ActiveArrow : null].join(' ')} />

                                                        </div>
                                                        {this.state.programDropdownOpen
                                                            ? <div className={classes.TopbarDropdown}>
                                                                <span>Select Module</span>
                                                                <ul className={classes.ProgramList}>
                                                                    {modulesList}
                                                                </ul>
                                                                <Link to={RouteEndPoints.ALL_MODULES_PAGE} className={classes.RemoveTextDecoration} onClick={this.onProgramDropdownClick}>
                                                                    <p className={classes.AllModulesTextLink}>VIEW ALL MODULES</p>
                                                                </Link>
                                                            </div>
                                                            : null}
                                                    </>
                                                    : <div className={classes.TopbarProgramDropdown} style={{ 'cursor': 'auto' }}>
                                                        <img src={this.state.currentModule.moduleLogo} alt="Module Logo"
                                                            className={classes.ModuleLogo} />
                                                        <div className={classes.ModuleTitleDiv}>
                                                            <h2 className={classes.ModuleName}>{this.state.currentModule.moduleName}</h2>
                                                            <p className={classes.ModuleDate}>{this.state.currentModule.startDate}  ({this.state.currentModule.batchCode})</p>
                                                        </div>
                                                    </div>
                                                : 'Loading...'
                                            }
                                        </div>
                                        {
                                            !IsObjectEmpty(this.state.ongoingModuleData.moduleMetaData)
                                                ? <>
                                                    <div className={classes.RightSection}>
                                                        <p className={classes.ModuleStats}>
                                                            {this.state.ongoingModuleData.moduleMetaData.activeStudents}
                                                            <span className={classes.ModuleStatsSubText}> / {this.state.ongoingModuleData.moduleMetaData.totalStudents}</span><br />
                                                            <span className={classes.ModuleStatsText}>Active Students</span>
                                                        </p>
                                                        <p className={classes.ModuleStats}>
                                                            {this.state.ongoingModuleData.moduleMetaData.classGrade}
                                                            <span className={classes.ModuleStatsSubText}> %</span><br />
                                                            <span className={classes.ModuleStatsText}>Class Grade</span>
                                                        </p>
                                                        <p className={classes.ModuleStats}>
                                                            {this.state.ongoingModuleData.moduleMetaData.rating > 50 ? this.state.ongoingModuleData.moduleMetaData.rating / 20 : this.state.ongoingModuleData.moduleMetaData.rating / 10}<br />
                                                            <span className={classes.ModuleStatsText}>My Rating</span>
                                                        </p>
                                                    </div>
                                                </>
                                                : null
                                        }
                                    </>
                            }
                        </div>
                }
            </>
        );
    }
}


const mapStateToProps = state => {
    return {
        enrolledPrograms: state.enrolledProgramsList,
        enrolledModules: state.enrolledModulesList,
        ongoingModuleData: state.ongoingModuleData,
        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        activeModuleId: state.activeModuleId,
        continueLearningData: state.continueLearningData,
        showTopbarProgramProgress: state.showTopbarProgramProgress,
        showModuleProgress: state.showModuleProgress,
        ongoingProgram: state.ongoingProgramDetails,
        hideProgramStrip: state.hideProgramStrip
    };
}

const mapDisptachToProps = dispatch => {
    return {
        setActiveProgramId: (data) => dispatch(actionCreators.setActiveProgramId(data)),
        setActiveModuleId: (moduleId, batchCode, moduleName) => dispatch(actionCreators.setActiveModuleId(moduleId, batchCode, moduleName)),
        setInitialProgramData: (continueLearningData, ongoingProgram, enrolledPrograms) => dispatch(actionCreators.setInitialProgramData(continueLearningData, ongoingProgram, enrolledPrograms)),

        setInitialModuleData: (moduleOverviewData, ongoingModule, enrolledModules) => dispatch(actionCreators.setInitialModuleData(moduleOverviewData, ongoingModule, enrolledModules)),

        redirectToHome: (status) => dispatch(actionCreators.redirectToHome(status)),

        updateLeanerLiveSessionStatus: (liveSessionStarted, liveSessionData) => dispatch(actionCreators.updateLeanerLiveSessionStatus(liveSessionStarted, liveSessionData)),
    }
        ;
}

export default connect(mapStateToProps, mapDisptachToProps)(withRouter(TopbarProgramStrip));